import { observer } from 'mobx-react';
import { LivePersonaCardWrapper } from 'owa-groups-shared-components';
import * as React from 'react';

let styles = require('./GroupName.scss');
const classNames = require('classnames/bind');

export interface GroupNameProps {
    displayName: string;
    emailAddress: string;
    clientScenario: string;
    className?: string;
}

@observer
export default class GroupName extends React.Component<GroupNameProps> {
    public render(): any {
        return (
            <LivePersonaCardWrapper
                name={this.props.displayName}
                emailAddress={this.props.emailAddress}
                personaType={'Group'}
                className={classNames(styles.groupName, this.props.className)}
                clientScenario={this.props.clientScenario}>
                {this.props.displayName}
            </LivePersonaCardWrapper>
        );
    }
}
